// ── displayStatus color map ──────────────────────────────
export const DISPLAY_STATUS_STYLES: Record<string, string> = {
  CLOUD_DISCOVERED:
    "bg-blue-50 dark:bg-blue-500/10 text-blue-700 dark:text-blue-300",
  ON_PREM_DISCOVERED:
    "bg-blue-50 dark:bg-blue-500/10 text-blue-700 dark:text-blue-300",
  CONTROLS_ASSIGNED:
    "bg-amber-50 dark:bg-amber-500/10 text-amber-700 dark:text-amber-300",
  IMPLEMENTED:
    "bg-emerald-50 dark:bg-emerald-500/10 text-emerald-700 dark:text-emerald-300",
  INHERITED:
    "bg-indigo-50 dark:bg-indigo-500/10 text-indigo-700 dark:text-indigo-300",
};

// Level pill (impact rating) styles
export const SYS_LEVEL_STYLES: Record<string, string> = {
  high: "bg-red-50 text-red-600 border-red-200 dark:bg-red-500/10 dark:text-red-400 dark:border-red-500/30",
  moderate:
    "bg-amber-50 text-amber-700 border-amber-200 dark:bg-amber-500/10 dark:text-amber-400 dark:border-amber-500/30",
  low: "bg-emerald-50 text-emerald-700 border-emerald-200 dark:bg-emerald-500/10 dark:text-emerald-400 dark:border-emerald-500/30",
};

// System status pill styles
export const SYS_STATUS_STYLES: Record<string, string> = {
  operational:
    "bg-emerald-50 text-emerald-700 border-emerald-200 dark:bg-emerald-500/10 dark:text-emerald-400 dark:border-emerald-500/30",
  "under-development":
    "bg-amber-50 text-amber-700 border-amber-200 dark:bg-amber-500/10 dark:text-amber-400 dark:border-amber-500/30",
  "under-major-modification":
    "bg-amber-50 text-amber-700 border-amber-200 dark:bg-amber-500/10 dark:text-amber-400 dark:border-amber-500/30",
  disposition:
    "bg-slate-50 text-slate-700 border-slate-200 dark:bg-slate-500/10 dark:text-slate-300 dark:border-slate-500/30",
  other:
    "bg-slate-50 text-slate-700 border-slate-200 dark:bg-slate-500/10 dark:text-slate-300 dark:border-slate-500/30",
};
